import { useEffect, useLayoutEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const PRESERVE_SCROLL_PREFIXES = [
  "/study/",
  "/view/",
  "/public/notes/",
  "/public/flashcards/",
  "/shared/",
  "/community/",
  "/tutorial/lesson",
  "/public/lesson/",
];

const shouldPreserveScroll = ({ pathname, hash }) => {
  if (hash) return true;
  return PRESERVE_SCROLL_PREFIXES.some((prefix) => pathname.startsWith(prefix));
};

const resetScrollPosition = () => {
  const appScrollContainer = document.querySelector(".app-app");
  appScrollContainer?.scrollTo({ top: 0, left: 0, behavior: "auto" });
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
};

const RouteScrollReset = () => {
  const location = useLocation();
  const previousPathnameRef = useRef(location.pathname);

  useEffect(() => {
    if (!("scrollRestoration" in window.history)) return undefined;

    const previousScrollRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";

    return () => {
      window.history.scrollRestoration = previousScrollRestoration;
    };
  }, []);

  useLayoutEffect(() => {
    const previousPathname = previousPathnameRef.current;
    previousPathnameRef.current = location.pathname;

    if (shouldPreserveScroll(location)) return;
    if (previousPathname === location.pathname) {
      resetScrollPosition();
      requestAnimationFrame(resetScrollPosition);
      return;
    }

    resetScrollPosition();
  }, [location]);

  return null;
};

export default RouteScrollReset;
